import Anchor from 'components/typography/anchor';
import PropTypes from 'prop-types';
import slugify from 'slugify';
import { AncillaryPersonType } from 'utilities/propTypes';
import { getShortTargetTypeHumanName } from 'utilities/targets';

// Add more types here as we add more types of representatives and want to control the order
const GROUPING_ORDER = ['state_upper', 'state_lower', 'mayor'];

const AncillaryPersonSummary = ({ groupedRepresentatives, stateCode }) => {
  // Get all the keys, but put ones we expected first
  const allRepTargetTypes = [
    ...new Set([...GROUPING_ORDER, ...Object.keys(groupedRepresentatives)]),
  ];
  return (
    <>
      {allRepTargetTypes.map((repType) => {
        const reps = groupedRepresentatives[repType];

        // For when a type is in the grouping priority list, but there are no reps of that type in the data
        if (!reps) {
          return null;
        }

        return (
          <section key={repType} className="mt-4">
            {/* Rep Type Heading */}
            <h2>{`${getShortTargetTypeHumanName(repType, stateCode)}s`}</h2>
            {/* List of reps of that type */}
            <ul className="flex flex-wrap gap-x-2">
              {reps.map((rep) => {
                const link = `/explore/person/${encodeURIComponent(
                  rep.id
                )}/${slugify(rep.name)}`;
                return (
                  <li
                    key={`ancillary-${rep.name}-${rep.location}`}
                    className="whitespace-nowrap"
                  >
                    <Anchor
                      className="anchor-subtle no-underline hover:underline"
                      href={link}
                    >
                      {rep.name}
                      <span>{rep.location ? ` (${rep.location})` : ``}</span>
                    </Anchor>
                  </li>
                );
              })}
            </ul>
          </section>
        );
      })}
    </>
  );
};

AncillaryPersonSummary.propTypes = {
  groupedRepresentatives: PropTypes.shape({
    state_upper: PropTypes.arrayOf(AncillaryPersonType),
    state_lower: PropTypes.arrayOf(AncillaryPersonType),
    mayor: PropTypes.arrayOf(AncillaryPersonType),
  }).isRequired,
  stateCode: PropTypes.string,
};

export default AncillaryPersonSummary;
